import React, { useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import gsap from "gsap";
import { HiOutlineX } from "react-icons/hi";
import { nav } from "../data/siteData";
import "./MobileMenu.css";

export default function MobileMenu({ open, onClose }) {
  const overlayRef = useRef(null);
  const circleRef = useRef(null);
  const linksRef = useRef([]);

  useEffect(() => {
    if (!overlayRef.current) return;

    if (open) {
      document.body.style.overflow = "hidden";
      const tl = gsap.timeline();
      tl.set(overlayRef.current, { display: "flex" })
        .fromTo(
          overlayRef.current,
          { opacity: 0 },
          { opacity: 1, duration: 0.35, ease: "power2.out" }
        )
        .fromTo(
          circleRef.current,
          { scale: 0 },
          { scale: 1, duration: 0.7, ease: "power3.out" },
          "-=0.15"
        )
        .fromTo(
          linksRef.current,
          { y: 30, opacity: 0 },
          { y: 0, opacity: 1, duration: 0.5, stagger: 0.08, ease: "power3.out" },
          "-=0.35"
        );
    } else {
      document.body.style.overflow = "";
      gsap.to(overlayRef.current, {
        opacity: 0,
        duration: 0.3,
        ease: "power2.in",
        onComplete: () => {
          gsap.set(overlayRef.current, { display: "none" });
        },
      });
    }
  }, [open]);

  return (
    <div className="mobile-menu" ref={overlayRef} role="dialog" aria-modal="true">
      <div className="mobile-menu__circle" ref={circleRef} />
      <button
        type="button"
        className="mobile-menu__close"
        onClick={onClose}
        aria-label="Close menu"
      >
        <HiOutlineX size={28} />
      </button>
      <nav className="mobile-menu__links" aria-label="Mobile">
        {nav.map((item, i) => (
          <NavLink
            key={item.path}
            to={item.path}
            className="mobile-menu__link"
            ref={(el) => (linksRef.current[i] = el)}
            onClick={onClose}
          >
            {item.label}
          </NavLink>
        ))}
      </nav>
      <NavLink to="/contact" className="btn btn-primary mobile-menu__cta" onClick={onClose}>
        Get Solar Quote
      </NavLink>
    </div>
  );
}
